import '../../../sass/screens/reset_password/index.scss';
import { addPasswordHintToForm } from '../../components/form/password_hint';

$(document).ready(() => {
  const resetPasswordFrom = $('#reset-password-form');
  addPasswordHintToForm(resetPasswordFrom, 'new_password1');
});
